import { render } from "./PaymentInProgress.vue?vue&type=template&id=367695a5"
import script from "./PaymentInProgress.vue?vue&type=script&lang=js"
export * from "./PaymentInProgress.vue?vue&type=script&lang=js"

import "./PaymentInProgress.vue?vue&type=style&index=0&id=367695a5&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__